import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { CourtsApiService } from 'src/app/core/services/api/courts-api.service';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { HearingsApiService } from 'src/app/core/services/api/hearings-api.service';
import { LawyersApiService } from 'src/app/core/services/api/lawyers-api.service';
import { MarineApiService } from 'src/app/core/services/api/marine-api.service';
import { OpponentsApiService } from 'src/app/core/services/api/opponents-api.service';
import { CaseSearchParams } from 'src/app/shared/models/cases/caseSearchParams';
import { NgSelectProps } from 'src/app/shared/models/ng-select-props';

interface tableCol {
  prop: string;
  name: string;
  format: string;
}
@Component({
  selector: 'app-files-filter',
  templateUrl: './files-filter.component.html',
  styleUrls: ['./files-filter.component.scss']
})

export class FilesFilterComponent implements OnInit {

  public filesNgSelect = null;
  public lawsuitsNgSelect = null;
  public clientsNgSelect = null;
  public lawyersNgSelect = null;
  public caseSubjectsNgSelect = null;
  public opponentsNgSelect = null;
  public shipsNgSelect = null;
  public ownersNgSelect = null;
  public ownerClubsNgSelect = null;
  public chartersNgSelect = null;
  public charterClubsNgSelect = null;
  public representativesNgSelect = null;
  public nmLawyersNgSelect = null;
  public courtsNgSelect = null;
  public circlesNgSelect = null;
  public crmLawyersNgSelect = null;
  public cityNgSelect = null;

  public statuses = [{ name: 'Opened', value: 1 }, { name: 'Pending', value: 2 }, { name: 'Closed', value: 3 }]
  columns: tableCol[] = [];
  modalRef: NgbModalRef;
  @Input() params: CaseSearchParams;
  @Input() client: boolean = true;
  @Output() apply: EventEmitter<{
    p: CaseSearchParams,
    cols: tableCol[]
  }> = new EventEmitter<{
    p: CaseSearchParams,
    cols: tableCol[]
  }>();
  @Output() reset: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('filterModal') filterModal;


  constructor(
    private filesApi: FilesApiService,
    private hearingsApi: HearingsApiService,
    private clientsApi: ClientsApiService,
    private lawyerApi: LawyersApiService,
    private opponentsApi: OpponentsApiService,
    private modalService: NgbModal,
    private marineApi: MarineApiService,
    private courtApi: CourtsApiService,
  ) {
  }

  ngOnInit() {
    this.filesNgSelect = new NgSelectProps(this.filesApi.getFilesTiny);
    this.lawsuitsNgSelect = new NgSelectProps(this.hearingsApi.getLawsuits);
    this.shipsNgSelect = new NgSelectProps(this.marineApi.getShips);
    this.clientsNgSelect = new NgSelectProps(this.clientsApi.getClientTiny);
    this.lawyersNgSelect = new NgSelectProps(this.lawyerApi.getLawyersLite);
    this.caseSubjectsNgSelect = new NgSelectProps(this.filesApi.getCaseSubjects);
    this.opponentsNgSelect = new NgSelectProps(this.opponentsApi.getOpponents);
    this.shipsNgSelect = new NgSelectProps(this.marineApi.getShips);
    this.ownersNgSelect = new NgSelectProps(this.marineApi.getOwners);
    this.ownerClubsNgSelect = new NgSelectProps(this.marineApi.getClubs);
    this.chartersNgSelect = new NgSelectProps(this.marineApi.getCharters);
    this.charterClubsNgSelect = new NgSelectProps(this.marineApi.getClubs);
    this.representativesNgSelect = new NgSelectProps(this.marineApi.getRepresentatives);
    this.nmLawyersNgSelect = new NgSelectProps(this.lawyerApi.getLawyersLite);
    this.courtsNgSelect = new NgSelectProps(this.courtApi.getCourts);
    this.circlesNgSelect = new NgSelectProps(this.courtApi.getCircles);
    this.crmLawyersNgSelect = new NgSelectProps(this.lawyerApi.getLawyersLite);
    this.cityNgSelect = new NgSelectProps(this.courtApi.getCities);

  }

  openModal() {
    this.modalRef = this.modalService.open(this.filterModal, { centered: true, size: 'lg' });
  }

  onFilterApply() {
    this.apply.emit({ p: this.params, cols: this.columns });

  }

  close() {
    this.modalRef?.close();
  }

  trackByFn(item) {
    return item.id;
  }
  trackCityByFn(item) {
    return item.cityEn + item.cityAr;
  }

  resetFilter() {
    // this.params = new CaseSearchParams();
    // this.apply.emit({ p: this.params, cols: this.columns });
    this.reset.emit();
  }

  addCol(e, col: tableCol) {
    const hasValue: boolean = (e.length > 0 || (e.target && e.target.value));
    if (hasValue) {
      if (!this.columns.find((value, index, array) => (value.prop === col.prop)
      )) {
        this.columns.push(col);
      }
    } else {
      this.columns = this.columns.filter((value, index, array) => value.prop !== col.prop);
    }
  }

  searchFn() {
    return true;
  }
}
